import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import ToggleArrow from '../../../../../../../shared/components/ToggleArrow';
import { BodyText, TinyTitleBold } from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import { CMSDataObjectPageService } from '~/App/views/ObjectPage/cmsDataHandlers';
import { Image, ResponsiveImageType } from 'react-datocms';

const Container = styled.div`
  display: flex;
  padding: 1rem 0;
  cursor: pointer;
  gap: 1rem;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 1rem;

  svg {
    font-size: 1.5rem;
  }
`;

interface Props {
  title: string;
  icon: FunctionComponent | CMSDataObjectPageService['icon'];
  isExpanded: boolean;
  responsiveImage?: ResponsiveImageType | null;
  description: string;
  toggleExpanded(): void;
  ariaControls: string;
}

const Header = ({
  icon,
  title,
  isExpanded,
  toggleExpanded,
  description,
  responsiveImage,
  ariaControls
}: Props) => {
  const { t } = useTranslation();

  return (
    <Container
      onClick={toggleExpanded}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleExpanded();
        }
      }}
      role="button"
      tabIndex={0}
      aria-expanded={isExpanded}
      aria-controls={ariaControls}
    >
      {responsiveImage && (
        <Image
          data={responsiveImage}
          style={{ width: '5rem', height: '5rem', borderRadius: '5rem' }}
        />
      )}
      <Content>
        <TitleContainer>
          {typeof icon === 'object' ? (
            <img alt={icon?.alt ?? t('Service icon')} src={icon?.url} />
          ) : (
            (icon as unknown as React.ReactNode)
          )}
          <TinyTitleBold>{title}</TinyTitleBold>
        </TitleContainer>
        <BodyText>{description}</BodyText>
      </Content>
      <ToggleArrow isExpanded={isExpanded} />
    </Container>
  );
};
export default Header;
